import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import {
  buildSimilarVehiclesCrossShopPath,
  CoreResearchModel,
  CoreResearchEntities,
} from 'client/data/models/core-research';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

export function SeoAlsoViewedVehiclesUI({ similarVehicles, isMobile, isUsed }) {
  if (!similarVehicles || !similarVehicles.length) {
    return null;
  }
  const moduleStyle = {
    overflowX: isMobile ? 'auto' : 'hidden',
    overflowY: 'hidden',
  };
  const cardStyle = {
    height: isMobile ? '339px' : '317px',
    width: '240px',
    border: 'solid #000 1px',
  };

  return (
    <div>
      <h2 className="heading-3 mb-1_25 mb-md-2 text-start">People who viewed this also viewed</h2>
      <div style={moduleStyle} className="d-flex pb-1">
        {similarVehicles.map((vehicle, index) => {
          const key = `also-viewed-vehicle-${index}`;
          const {
            make: { name: makeName, slug: makeSlug },
            model: { name: modelName, slug: modelSlug },
            year,
            startPrice,
            consumerRating,
          } = vehicle;

          return (
            <Fragment key={key}>
              <a style={cardStyle} className="me-1" href={getCoreUrl({ makeSlug, modelSlug, year })}>
                <table style={cardStyle}>
                  <thead>
                    <tr>
                      <td>
                        <header>
                          {makeName} {modelName}
                        </header>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {consumerRating && (
                      <tr>
                        <td>
                          {parseFloat(consumerRating.averageRating).toFixed(1)} average Rating out of{' '}
                          {consumerRating.reviewsCount} reviews.
                        </td>
                      </tr>
                    )}
                    {startPrice && (
                      <tr>
                        <td>
                          <span>Starting at {formatPriceString(startPrice)}</span>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </a>
              {isUsed && (
                <a href={`/used-${makeSlug}-${modelSlug}/`}>
                  See {makeName} {modelName} Inventory
                </a>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}

SeoAlsoViewedVehiclesUI.propTypes = {
  similarVehicles: PropTypes.arrayOf(CoreResearchEntities.SimilarVehicleCrossShop),
  isUsed: PropTypes.bool,
  isMobile: PropTypes.bool,
};
SeoAlsoViewedVehiclesUI.defaultProps = {
  similarVehicles: null,
  isUsed: false,
  isMobile: false,
};

export const SeoAlsoViewedVehicles = connectToModel(SeoAlsoViewedVehiclesUI, {
  similarVehicles: bindToPath(
    ({ modelLinkCode }) => buildSimilarVehiclesCrossShopPath(modelLinkCode),
    CoreResearchModel
  ),
});

SeoAlsoViewedVehicles.propTypes = {
  modelLinkCode: PropTypes.string.isRequired,
  isUsed: PropTypes.bool,
  isMobile: PropTypes.bool,
};

SeoAlsoViewedVehicles.defaultProps = {
  isUsed: false,
  isMobile: false,
};
